import {
    EventsLoadState,
    getLoadStateForCalendar as getLoadState,
} from 'owa-calendar-events-loader';
import { getScenarioListCacheId } from '../selectors/agendaStoreSelectors';

export function getLoadStateForCalendar(scenarioId: string, calendarId: string): EventsLoadState {
    return getLoadState(getScenarioListCacheId(scenarioId), calendarId) ?? 'NotLoaded';
}
